import { render } from "./StockTrackingGroupList.vue?vue&type=template&id=3088a50b&scoped=true"
import script from "./StockTrackingGroupList.vue?vue&type=script&lang=js"
export * from "./StockTrackingGroupList.vue?vue&type=script&lang=js"

import "./StockTrackingGroupList.vue?vue&type=style&index=0&id=3088a50b&scoped=true&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3088a50b"]])

export default __exports__